var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"c-clipboard",on:{"click":function($event){return _vm.copyToClipboard()}}},[_c('Icon',{staticClass:"fs-18",attrs:{"icon":"fa-regular:copy"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }